import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import {IProcessFlowCallToActionShowListView} from "~/interfaces/processFlowInterfaces"
import ListView from "~/models/listViews/listView"
import {IListView} from "~/interfaces/listViewInterfaces"

/**
 * Show a list view
 */
export default class ShowListViewCallToAction extends ProcessFlowCallToAction implements IProcessFlowCallToActionShowListView {
  action_type: CallToActionType.ListView
  list_view_id: string

  constructor(protected _rootName: string, options: any = {}) {
    super(_rootName, options)
    this.defineProperty('list_view_id', null)
    this.defineProperty('button_label', 'View List')
  }

  get listView(): IListView {
    if (!this.list_view_id) return

    return ListView.repo.find(this.list_view_id)
  }

  get isValid(): boolean {
    return (!this.buttonLabelRequired || Boolean(this.button_label)) &&
      Boolean(this.list_view_id)
  }
}